import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ENTITY } from 'src/consts'
import useWidth from 'src/hooks/useWidth'
import { getExchangesDict } from 'src/redux/selectors'
import {
  getMarketsCurrencySelector,
  getMarketsDataSelector,
  getMarketsFailedStatusSelector,
  getMarketsFetchingStatusSelector,
} from 'src/redux/selectors/markets'
import { getMarketsData, getRemoteMapData } from 'src/redux/thunks'
import styles from './styles.module.scss'

const MarketsCoinContainer = dynamic(() => import('./MarketsCoinContainer'), {
  ssr: false,
})

type Props = {
  name: string
  slug: string
  mapDataArray?: []
}

export const MarketsTab = ({ name, slug, mapDataArray }: Props) => {
  const router = useRouter()
  const { isMobile } = useWidth()
  const dispatch = useDispatch()
  const marketsData = useSelector(state =>
    // @ts-ignore
    getMarketsDataSelector(state, ENTITY.COIN)
  )
  const marketsCurrency = useSelector(getMarketsCurrencySelector)
  const isFetching = useSelector(getMarketsFetchingStatusSelector)
  const isFailed = useSelector(getMarketsFailedStatusSelector)
  const exchangesDict = useSelector(getExchangesDict)

  const dispatchGetMarketsData = params => {
    return dispatch(getMarketsData(params))
  }

  const dispatchGetExchanges = () => {
    return dispatch(getRemoteMapData({ entity: ENTITY.EXCHANGE }))
  }

  return (
    <div className={styles.root}>
      <MarketsCoinContainer
        exchangeLink=''
        slug={slug}
        exchangesDict={exchangesDict}
        getMarketsData={dispatchGetMarketsData}
        getExchangesData={dispatchGetExchanges}
        marketsCurrency={marketsCurrency}
        isFetching={isFetching}
        entity={ENTITY.COIN}
        isFailed={isFailed}
        isMobile={isMobile}
        location={router.pathname}
        marketsData={marketsData}
        name={name}
        push={router.push}
        mapDataArray={mapDataArray}
      />
    </div>
  )
}

export default MarketsTab
